export default __webpack_public_path__ + "static/sboyd-ec800c5ff9d2cf59c1d8aaa8d91c8eb7.png";